/* eslint-disable radix */
import React, { useState, useEffect, useRef } from 'react'
import { Query, Mutation } from 'react-apollo'
import {
  Div, LoadingIcon, H4, Icon,
} from 'konsys-ui'
import PATH from '../../../constants/path'
import Banner from '../../../images/packaging-catalog/banner.jpg'
import { theme } from '../../../styles/_variables'
import Container from '../../../components/container'
import * as ModalAlert from '../../../components/common/modal'
import { GET_PACKAGE_DETAIL, PRICE_CALCULATOR } from '../../../constants/graph/query'
import { UPLOAD_GENERAL_FILE } from '../../../constants/graph/mutation'
import Detail from './components/detail'
import Parts from './components/parts'
import Summary from './components/summary'
import SummaryContent from './components/summary-content'
import {
  ActionZone,
  ActionZone2,
  ButtonCalculator,
  Content,
  WidthContainer,
  ContentPart,
  SummaryDivMobile,
  IconCalculate,
  ButtonBack,
  Title,
  Bar,
  ButtonFormAction,
  SummaryPanel,
  SummaryToggle,
  FooterContent,
} from './styled'
import CalculationIcon from '../../../images/icon/CalculationIcon.png'


const PackagingDetail = ({
  match,
}) => {
  const [step, setStep] = useState(1)
  const [formValues, setFormValues] = useState({
    showPromotion: true,
    amountProduction: 0,
    productionType: 'newOrder',
    widthHoldingTax: false,
    graphicId: 0,
    moreDetail: '',
    incrementalSteps: 0,
    minimumManufacture: 0,
    graphicFile: [],
    partData: [],
    partDetail: [],
    totalCost: [],
    listCost: [],
    isBack: false,
  })
  const [activeTab, setActiveTab] = useState(0)
  const [callCalculation, setCallCalculation] = useState(false)

  const onChangeTab = (key) => {
    setActiveTab(key)
  }

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 375)
  const [isMobileXL, setIsMobileXL] = useState(window.innerWidth <= 960)

  const screenSizeHandler = () => setIsMobileView(window.innerWidth <= 375)
  const screenSizeHandler2 = () => setIsMobileXL(window.innerWidth <= 960)

  useEffect(() => {
    window.addEventListener('resize', screenSizeHandler)
    window.addEventListener('resize', screenSizeHandler2)
    return () => {
      window.removeEventListener('resize', screenSizeHandler)
      window.removeEventListener('resize', screenSizeHandler2)
    }
  }, [])

  const ContentRef = useRef(null)

  useEffect(() => {
    const element = document.body
    if (element) {
      setTimeout(async () => {
        await element.scrollIntoView({
          behavior: 'smooth',
        })
      }, 500)
    }
  }, [formValues.isBack])

  const [disabled, setDisabled] = useState(false)
  const [disabledRequestQuot, setDisabledRequestQuot] = useState(false)

  const [summaryActive, setSummaryActive] = useState(false)


  const handleClickToggle = () => {
    setSummaryActive(!summaryActive)
    if (!summaryActive) {
      document.body.style.overflowY = 'hidden'
    } else {
      document.body.style.overflowY = 'unset'
    }
  }

  return (
    <Query
      query={GET_PACKAGE_DETAIL}
      fetchPolicy='network-only'
      variables={{
        id: parseInt(match.params.id, 10),
      }}
      notifyOnNetworkStatusChange
      onCompleted={(data) => {
        const oldFormValuesPackage = localStorage.getItem('package') && JSON.parse(localStorage.getItem('package'))
        if (oldFormValuesPackage) {
          setFormValues({
            ...formValues,
            moreDetail: oldFormValuesPackage.moreDetail,
            graphicFile: oldFormValuesPackage.graphicFile,
            graphicId: oldFormValuesPackage.graphicId,
            partData: oldFormValuesPackage.partData,
            incrementalSteps: oldFormValuesPackage.incrementalSteps,
            minimumManufacture: oldFormValuesPackage.minimumManufacture,
            amountProduction: oldFormValuesPackage.amountProduction,
            totalCost: oldFormValuesPackage.totalCost,
            listCost: oldFormValuesPackage.listCost,
            productionType: oldFormValuesPackage.productionType,
            isBack: true,
            minimumTotalCost: oldFormValuesPackage.minimumTotalCost,
            amountTotalCost: oldFormValuesPackage.amountTotalCost,
          })
          setStep(2)
        } else if (data.packaging.success) {
          const packagingData = data.packaging.package
          if (packagingData.status === 'active') {
            const formPartData = packagingData.packageParts.map((item) => {
              const variables = Array.from(Array(item.amountVariablePart)).map((_e, i) => String.fromCharCode('a'.charCodeAt() + i))
              const sizeList = {}
              variables.forEach((v) => { sizeList[v] = null })
              return (
                {
                  packagePartId: item.packagePartId,
                  packagePartName: item.name,
                  packageData: packagingData,
                  measurementUnit: {
                    value: 1,
                    text: 'เซนติเมตร (ซม.)',
                    key: 'cm',
                    label: 'ซม.',
                  },
                  sizeList,
                  sampleImage: item.packagePartFiles,
                  printing: {
                    selectedPrinting: 0,
                    side: null,
                    printingId: null,
                    printingName: '',
                    printingType: 1,
                    printingTypeName: 'พิมพ์หน้าเดียว',
                    printingBasicColorId: 0,
                    printingBasicColorName: '',
                    checkExtraColor: false,
                    printingExtraColorId: [],
                  },
                  paperList: item.paper.sort((a, b) => a.paperId - b.paperId),
                  paper: {
                    paperId: item.paper[0].paperId,
                    name: '',
                    thickness: item.paper[0].paperThickness.length > 0 ? item.paper[0].paperThickness[0].thickness : [],
                    selectedThickness: item.paper[0].paperThickness.length > 0 && item.paper[0].paperThickness[0].thickness,
                    coatingFrontIds: [],
                    coatingBackIds: [],
                  },
                  coating: {
                    side: 0,
                    coatingType: 'ไม่เคลือบ',
                    coatingFrontId: null,
                    coatingFrontName: '',
                    coatingBackId: null,
                    coatingBackName: '',
                  },
                  spotUV: {
                    side: 0,
                    spotUVType: 'ไม่เคลือบ',
                    spotUVFrontId: null,
                    spotUVFrontName: '',
                    spotUVBackId: null,
                    spotUVBackName: '',
                  },
                  selectedEmbossing: 0,
                  embossing: [],
                  foilingId: 0,
                  foilingName: '',
                  foiling: [],
                  selectedPlasticWindow: 0,
                  plasticWindow: [],
                  gluing: item.gluing,
                  additionalService: item.additionalService,
                  isDieCut: item.isDieCut,
                }
              )
            })
            setFormValues({
              ...formValues,
              partData: formPartData,
              incrementalSteps: packagingData.incrementalSteps,
              minimumManufacture: packagingData.minimumManufacture,
              amountProduction: packagingData.minimumManufacture,
            })
          } else {
            ModalAlert.alertError('ไม่พบข้อมูลบรรจุภัณฑ์นี้ ขออภัยในความไม่สะดวก')
            // message.error('ไม่พบข้อมูลบรรจุภัณฑ์นี้ ขออภัยในความไม่สะดวก')
            setTimeout(() => {
              window.location = `${PATH.packaging}`
            }, 1000)
          }
        } else {
          ModalAlert.alertError(data.packaging.message)
          // message.error(data.packaging.message)
          setTimeout(() => {
            window.location = `${PATH.packaging}`
          }, 1000)
        }
      }}
    >
      {
        ({ loading, data }) => {
          if (loading) {
            return (
              <Container header={{
                type: 'title',
                img: Banner,
                title: '',
                color: theme.color.offWhite,
              }}>
                <WidthContainer>
                  <Div moreStyle={{ paddingTop: '148px', paddingBottom: '200px' }}>
                    <Div margin='24px 0' textAlign='center'><LoadingIcon color={theme.color.grey} /></Div>
                  </Div>
                </WidthContainer>
              </Container>
            )
          }
          if (!data.packaging.success) {
            return (
              <Container header={{
                type: 'title',
                img: Banner,
                title: 'ชื่อบรรจุภัณฑ์',
                color: theme.color.offWhite,
              }}>
                <WidthContainer>
                  <Div moreStyle={{ paddingTop: '148px', paddingBottom: '200px' }}>
                    <H4>ขออภัยค่ะ {data.packaging.message}</H4>
                  </Div>
                </WidthContainer>
              </Container>
            )
          }
          const packagingData = data.packaging.package
          if (packagingData.status === 'inactive') {
            return (
              <Container header={{
                type: 'title',
                img: Banner,
                title: 'ชื่อบรรจุภัณฑ์',
                color: theme.color.offWhite,
              }}>
                <WidthContainer>
                  <Div moreStyle={{ paddingTop: '148px', paddingBottom: '200px' }}>
                    <H4>ขออภัยค่ะ ไม่พบข้อมูลบรรจุภัณฑ์ดังกล่าว</H4>
                  </Div>
                </WidthContainer>
              </Container>
            )
          }
          return (
            <React.Fragment>
              {
                isMobileXL && <SummaryPanel active={summaryActive}>
                  <SummaryToggle onClick={() => handleClickToggle()}>
                    <h4></h4>
                    <h4>สรุปรายละเอียด</h4>
                    <Icon
                      style={{
                        color: theme.color.offWhite,
                        fontSize: '20px',
                        fontWeight: '500',
                      }}
                      icon={summaryActive ? 'fal fa-chevron-down' : 'fal fa-chevron-up'}
                    />
                  </SummaryToggle>
                  <SummaryDivMobile step={step} active={summaryActive}>
                    <Summary
                      formValues={formValues}
                      activeTab={activeTab}
                      onChangeTab={onChangeTab}
                      sticky={false}
                      step={step}
                      setStep={setStep}
                      isFixedPosition
                      setSummaryActive={handleClickToggle}
                    />
                  </SummaryDivMobile>
                </SummaryPanel>
              }
              <Container header={{
                type: 'title',
                img: Banner,
                title: packagingData.name,
                color: theme.color.offWhite,
              }}>
                <Div style={{
                  overflow: isMobileXL ? 'hidden' : 'visible',
                  backgroundColor: theme.color.offWhite,
                  marginTop: '-20px',
                  paddingTop: '20px',
                }}>
                  {/* Title Detail Section */}
                  <Detail data={packagingData}/>
                  {/* Preview Component */}
                  <Content id='content-package' innerRef={(el) => { this.stepContainer = el }} step={step} data={packagingData.packageParts && packagingData.packageParts.length}>
                    <WidthContainer innerRef={ContentRef} isOne={packagingData.packageParts && packagingData.packageParts.length === 1}>
                      <Div>
                        {
                          step === 1 && formValues.partData.length > 0 && <ContentPart>
                            <Parts
                              data={packagingData}
                              formValues={formValues}
                              setFormValues={setFormValues}
                              activeTab={activeTab}
                              onChangeTab={onChangeTab}
                              isMobileXL={isMobileXL}
                              disabled={disabled}
                              setDisabled={setDisabled}
                              ContentRef={ContentRef}
                            />
                          </ContentPart>
                        }
                        {
                          step === 2 && <Div>
                            <Bar>
                              <Div>
                                <ButtonBack
                                  inverse
                                  text='<< ย้อนกลับ'
                                  onClick={async () => {
                                    setStep(1)
                                    await setFormValues({
                                      ...formValues,
                                      isBack: formValues.isBack,
                                    })
                                  }}
                                />
                              </Div>
                              <Title>ข้อมูลโปรโมชัน และราคา</Title>
                              <Div>
                                {
                                  !isMobileXL && <ButtonBack
                                    inverse
                                    text='<< ย้อนกลับ'
                                    style={{ opacity: 0, cursor: 'unset' }}
                                  />
                                }
                              </Div>
                            </Bar>
                            <Div display='flex' alignItems='center' justifyContent='center'>
                              <Div flexBasis={isMobileXL ? '100%' : '70%'}>
                                {
                                  formValues && formValues.listCost.length > 0 && <SummaryContent
                                    setFormValues={setFormValues}
                                    formValues={formValues}
                                    setStep={setStep}
                                    setDisabledRequestQuot={setDisabledRequestQuot}
                                  />
                                }
                              </Div>
                              {
                                !isMobileXL && <Div flexBasis='30%'>
                                  <Summary
                                    formValues={formValues}
                                    activeTab={activeTab}
                                    onChangeTab={onChangeTab}
                                    sticky={true}
                                    step={step}
                                    setStep={setStep}
                                    isNotTop={false}
                                    ContentRef={ContentRef}
                                    setSummaryActive={setSummaryActive}
                                  />
                                </Div>
                              }
                            </Div>
                          </Div>
                        }
                      </Div>
                    </WidthContainer>
                  </Content>
                  <FooterContent>
                    <WidthContainer top>
                        {
                          step === 1 && <ActionZone>
                            <Query
                              query={PRICE_CALCULATOR}
                            >
                              {
                                ({ refetch }) => (
                                  <ButtonCalculator
                                    inverse
                                    buttonStyle='round'
                                    loading={callCalculation}
                                    disabled={callCalculation || disabled}
                                    text={<React.Fragment><IconCalculate src={CalculationIcon} />คำนวณราคา</React.Fragment>}
                                    onClick={async () => {
                                      setCallCalculation(true)
                                      const findNullSizePart = formValues.partData.map(item => Object.values(item.sizeList).filter(v => v === null || v === '' || v === undefined))
                                      const findNullSize = Array.prototype.concat.apply([], findNullSizePart).filter(v => v === null || v === '' || v === undefined || v === 0)
                                      const findEmptyEmbossing = formValues.partData.filter(item => (item.selectedEmbossing === 1 && item.embossing.length === 0) || (item.embossing.length > 0 && item.embossing.filter(x => x.width === null || x.lengths === null).length > 0))
                                      const findEmptyFoiling = formValues.partData.filter(item => (item.foilingId > 0 && item.foiling.length === 0) || (item.foiling.length > 0 && item.foiling.filter(x => x.width === null || x.lengths === null).length > 0))
                                      const findEmptyPlastic = formValues.partData.filter(item => (item.selectedPlasticWindow === 1 && item.plasticWindow.length === 0) || (item.plasticWindow.length > 0 && item.plasticWindow.filter(x => x.width === null || x.lengths === null).length > 0))
                                      if (findNullSize.length > 0) {
                                        ModalAlert.alertWarning('ข้อมูลขนาดไม่ถูกต้อง กรุณาระบุขนาดใหม่อีกครั้ง')
                                        setCallCalculation(false)
                                        return
                                      }
                                      if (findNullSize.length > 0 || findEmptyEmbossing.length > 0 || findEmptyFoiling.length > 0 || findEmptyPlastic.length > 0) {
                                        ModalAlert.alertWarning(`กรุณากรอกข้อมูล ${findNullSize.length > 0 ? 'ขนาดบรรจุภัณฑ์' : ''} ${findEmptyEmbossing.length > 0 ? 'ตำแหน่งการปั๊มนูน' : ''} ${findEmptyFoiling.length > 0 ? 'ตำแหน่งการปั๊มฟอยล์-ทองเค' : ''} ${findEmptyPlastic.length > 0 ? 'ตำแหน่งการเจาะหน้าต่างและติดแผ่นใส' : ''} ให้ครบถ้วน`)
                                        setCallCalculation(false)
                                        return
                                      }
                                      const part = formValues.partData.map((item, index) => ({
                                        order: index + 1,
                                        packagePartId: item.packagePartId,
                                        unit: item.measurementUnit.key,
                                        operator: Object.values(item.sizeList).map(x => (parseFloat(x))),
                                        printSizeWidth: 0.0,
                                        printSizeLength: 0.0,
                                        paper: {
                                          paperId: item.paper.paperId,
                                          thickness: parseFloat(item.paper.selectedThickness),
                                        },
                                        printing: item.printing.side && {
                                          side: item.printing.printingType,
                                          printingBasicColorId: item.printing.printingBasicColorId,
                                          printingExtraColorId: item.printing.printingExtraColorId.filter(x => x.printingExtraColorId).map(x => x.printingExtraColorId),
                                        },
                                        coating: {
                                          coatingIdFront: item.coating.side === 1 || item.coating.side === 2 ? item.coating.coatingFrontId : null,
                                          coatingIdBehind: item.coating.side === -1 || item.coating.side === 2 ? item.coating.coatingBackId : null,
                                        },
                                        spotUV: {
                                          spotUVIdFront: item.spotUV.spotUVFrontId,
                                          spotUVIdBehind: item.spotUV.spotUVBackId,
                                        },
                                        embossing: item.embossing.map((x, i) => ({
                                          order: i + 1,
                                          width: parseFloat(x.width),
                                          length: parseFloat(x.lengths),
                                          unit: item.measurementUnit.key,
                                        })),
                                        foiling: {
                                          foilingId: item.foilingId !== 0 ? item.foilingId : null,
                                          foilingPart: item.foiling.map((x, i) => ({
                                            order: i + 1,
                                            width: parseFloat(x.width),
                                            length: parseFloat(x.lengths),
                                            unit: item.measurementUnit.key,
                                          })),
                                        },
                                        dieCut: item.isDieCut,
                                        plasticWindow: item.plasticWindow.map((x, i) => ({
                                          order: i + 1,
                                          width: parseFloat(x.width),
                                          length: parseFloat(x.lengths),
                                          thickness: x.thickness,
                                          unit: item.measurementUnit.key,
                                        })),
                                        gluingId: item.gluing ? item.gluing.gluingId : null,
                                        additionalServiceId: item.additionalService.map(x => x.additionalServiceId) || [],
                                      }))
                                      const input = {
                                        part,
                                      }
                                      await refetch({
                                        input,
                                      }).then(async (res) => {
                                        if (res.data.priceCalculator.success) {
                                          const quantity = [1, 500, 1000, 1500, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000]
                                          const indexMinimum = quantity.reverse().find(e => e <= parseInt(formValues.minimumManufacture))
                                          const index = quantity.reverse().indexOf(indexMinimum)
                                          const priceData = res.data.priceCalculator.totalCost.find(x => x.quantity === quantity[index])
                                          await setFormValues({
                                            ...formValues,
                                            partData: formValues.partData,
                                            partDetail: res.data.priceCalculator.partDetail,
                                            totalCost: res.data.priceCalculator.totalCost,
                                            listCost: res.data.priceCalculator.totalCost,
                                            pricePerPiece: formValues.productionType === 'newOrder' ? priceData.totalCost : priceData.totalRepeatCost,
                                            priceNewOrder: priceData.totalCost,
                                            priceRepeat: priceData.totalRepeatCost,
                                          })
                                          const element = document.getElementById('content-package')
                                          if (element) {
                                            setTimeout(async () => {
                                              setCallCalculation(false)
                                              await setStep(2)
                                              await element.scrollIntoView({
                                                behavior: 'smooth',
                                              })
                                            }, 500)
                                          }
                                        } else if (res.data.priceCalculator.message === 'oversize') {
                                          setCallCalculation(false)
                                          ModalAlert.alertWarning('ไม่สามารถให้บริการผลิตขนาดดังกล่าวได้ เนื่องจากมีขนาดเกินเครื่องพิมพ์ของทางเรา ขออภัยในความไม่สะดวก')
                                        } else if (res.data.priceCalculator.message === 'ขออภัย ขนาดที่ระบุ ไม่สามารถผลิตบนกระดาษชนิดนี้ได้') {
                                          setCallCalculation(false)
                                          ModalAlert.alertWarning('ขออภัย ขนาดที่ระบุ ไม่สามารถผลิตบนกระดาษชนิดนี้ได้')
                                        } else if (res.data.priceCalculator.message === 'ไม่สามารถคำนวณ Width ได้' || res.data.priceCalculator.message === 'ไม่สามารถคำนวณ Length ได้') {
                                          setCallCalculation(false)
                                          ModalAlert.alertWarning('ข้อมูลขนาดไม่ถูกต้อง กรุณาระบุขนาดใหม่อีกครั้ง')
                                        } else {
                                          setCallCalculation(false)
                                          ModalAlert.alertSuccess('สามารถให้บริการผลิตขนาดดังกล่าวได้')
                                        }
                                      }).catch((e) => {
                                        if (e.toString().includes('status code 400')) {
                                          setCallCalculation(false)
                                          ModalAlert.alertWarning('กรุณากรอกข้อมูลให้ครบถ้วน')
                                        } else {
                                          setCallCalculation(false)
                                          ModalAlert.alertError('ไม่สามารถคำนวนราคาได้')
                                          setStep(1)
                                        }
                                      })
                                    }}
                                  />
                                )
                              }
                            </Query>
                          </ActionZone>
                        }
                        {
                          step === 2 && <ActionZone2>
                              <ButtonFormAction
                                text='ย้อนกลับ'
                                onClick={async () => {
                                  if (isMobileXL) {
                                    setStep(1)
                                    await setFormValues({
                                      ...formValues,
                                      isBack: formValues.isBack,
                                    })
                                    await setStep(1)
                                    const element = document.getElementById('content-package')
                                    await element.scrollIntoView({
                                      behavior: 'smooth',
                                    })
                                  } else if (this.stepContainer) {
                                    setStep(1)
                                    await setFormValues({
                                      ...formValues,
                                      isBack: formValues.isBack,
                                    })
                                    await setStep(1)
                                    const element = document.getElementById('content-package')
                                    await element.scrollIntoView({
                                      behavior: 'smooth',
                                    })
                                  }
                                }}
                                inverse
                                color={theme.color.secondaryColor}
                                buttonStyle="round"
                                activeGreen={step === 3}
                                icon={'far fa-chevron-double-left'}
                                small={isMobileXL}
                                style={{ marginLeft: !isMobileXL && '12px' }}
                              />
                              <Mutation
                                mutation={UPLOAD_GENERAL_FILE}
                              >
                                {
                                  doUploadGeneralFile => (
                                    <ButtonFormAction
                                      small={true}
                                      // small={isMobileXL}
                                      text='ดำเนินการขอใบเสนอราคา'
                                      inverse
                                      color={theme.color.secondaryColor}
                                      buttonStyle="round"
                                      rightIcon
                                      activeGreen={step === 3}
                                      icon={'far fa-chevron-double-right'}
                                      style={{ marginRight: !isMobileXL && '12px' }}
                                      disabled={disabledRequestQuot}
                                      onClick={() => {
                                        const input = {
                                          generalFile: formValues.graphicFile.filter(item => item.size),
                                        }
                                        doUploadGeneralFile({
                                          variables: {
                                            input,
                                          },
                                        }).then((res) => {
                                          if (res.data.uploadGeneralFile) {
                                            if (res.data.uploadGeneralFile.success) {
                                              const tmpFormValues = formValues
                                              tmpFormValues.graphicFile = res.data.uploadGeneralFile.files.length ? res.data.uploadGeneralFile.files : formValues.graphicFile
                                              tmpFormValues.isBack = false
                                              localStorage.removeItem('package')
                                              localStorage.setItem('package', JSON.stringify(tmpFormValues))
                                              setTimeout(() => {
                                                window.location = `${PATH.request}?predefined=true`
                                              }, 200)
                                            } else {
                                              ModalAlert.alertError(res.data.uploadGeneralFile.message)
                                            }
                                          }
                                        })
                                      }}
                                    />
                                  )
                                }
                              </Mutation>
                          </ActionZone2>
                        }
                    </WidthContainer>
                  </FooterContent>
                </Div>
              </Container>
            </React.Fragment>
          )
        }
      }
    </Query>
  )
}

export default PackagingDetail



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/index.jsx